// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__XLSS3","inputDescription":"styles_inputDescription__2C3eR"};